import { mergeStyleSets } from "@fluentui/react";
import { ITheme } from "@theme/foundations";

const getStyles = (theme: ITheme) => mergeStyleSets({
    defaultLink: {
        color: theme.palette.gray2,
        fontSize: theme.fontSizes.xl,
        ':hover': {
            color: theme.palette.blue2,
        },
        '@media(max-width: 992px)': {
            fontSize: theme.fontSizes.m,
        }
    },
    secondaryLink: {
        color: theme.palette.gray2,
        fontSize: theme.fontSizes.xl,
        ':hover': {
            color: theme.palette.blue2,
        },
        '@media(max-width: 992px)': {
            fontSize: theme.fontSizes.m,
        }
    }
});

export default getStyles;